export default __webpack_public_path__ + "static/media/No.3-1.b78a7204.jpg";